import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Layout components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import CollegeListingPage from './pages/CollegeListingPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import CollegeDetailPage from './pages/CollegeDetailPage';
import NotFoundPage from './pages/NotFoundPage';

// College IDs for routing
const colleges = [
  { id: 'sourabh', name: 'Sourabh College of Veterinary Science' },
  { id: 'rps', name: 'RPS College of Veterinary Science' },
  { id: 'abhilashi', name: 'Abhilashi Veterinary College' },
];

// Services for routing
const services = [
  { id: 'counselling', name: 'Admission Counselling' },
  { id: 'application', name: 'Application Assistance' },
  { id: 'document', name: 'Documentation Support' },
  { id: 'interview', name: 'Interview Preparation' },
  { id: 'scholarship', name: 'Scholarship Guidance' },
];

function App() {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/colleges" element={<CollegeListingPage />} />
          
          {/* Dynamic routes for services */}
          {services.map(service => (
            <Route 
              key={service.id}
              path={`/services/${service.id}`} 
              element={<ServiceDetailPage serviceId={service.id} />} 
            />
          ))}
          
          {/* Dynamic routes for colleges */}
          {colleges.map(college => (
            <Route 
              key={college.id}
              path={`/colleges/${college.id}`} 
              element={<CollegeDetailPage collegeId={college.id} />} 
            />
          ))}
          
          {/* 404 route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;